module.exports = __webpack_public_path__ + "img/xing.1e4773f0.svg";